import { Avatar, Box, List, ListItemButton, Paper, Typography } from "@mui/material";
import { useContactCenterTheme } from "../../virtual-receptionist/theming/ContactCenterThemeContext";
import { MessageGroupMember } from "../messageGroups.types";
import { getAvatarColor, getMemberFullName, getMemberRoleLabel } from "../utils/messageGroupDisplay.utils";

interface MentionAutocompleteProps {
  members: MessageGroupMember[];
  activeIndex: number;
  onSelect: (member: MessageGroupMember) => void;
}

export const MentionAutocomplete = ({ members, activeIndex, onSelect }: MentionAutocompleteProps) => {
  const { theme } = useContactCenterTheme();

  if (members.length === 0) return null;

  return (
    <Paper
      elevation={6}
      sx={{
        position: "absolute",
        bottom: "calc(100% + 6px)",
        left: 8,
        right: 8,
        maxHeight: 200,
        overflowY: "auto",
        borderRadius: 2,
        zIndex: 20,
        backgroundColor: theme.chat.inputBg,
        border: `1px solid ${theme.shell.border}`,
      }}
    >
      <List dense disablePadding>
        {members.map((member, index) => {
          const name = getMemberFullName(member) || "Unknown";
          const role = getMemberRoleLabel(member);

          return (
            <ListItemButton
              key={`${member.type}:${member.uid}`}
              selected={index === activeIndex}
              onMouseDown={(event) => {
                event.preventDefault();
                onSelect(member);
              }}
              sx={{ gap: 1.25, py: 0.75 }}
            >
              <Avatar
                src={member.avatar || undefined}
                alt={name}
                sx={{ width: 26, height: 26, fontSize: "0.7rem", bgcolor: member.avatar ? undefined : getAvatarColor(name) }}
              >
                {name[0]?.toUpperCase() || "?"}
              </Avatar>
              <Box sx={{ minWidth: 0 }}>
                <Typography noWrap sx={{ fontSize: "0.82rem", fontWeight: 600, color: theme.shell.textPrimary }}>
                  {name}
                </Typography>
                {role ? (
                  <Typography noWrap sx={{ fontSize: "0.68rem", color: theme.shell.textSecondary, textTransform: "capitalize" }}>
                    {role}
                  </Typography>
                ) : null}
              </Box>
            </ListItemButton>
          );
        })}
      </List>
    </Paper>
  );
};
